export default {
    okText: 'Ок',
    dismissText: 'Отмена',
    extra: '',
};
